import { defineComponent as _defineComponent } from 'vue'
import AccountInformationViewObject = Vertica.LouisPoulsen.Application.Account.Api.Responses.MyAccount.AccountInformationViewObject;
import MultiFactorAuthenticationViewObject = Vertica.LouisPoulsen.Application.Account.Api.Responses.MultiFactorAuthenticationViewObject;
import ContactInformation from './ContactInformation.vue';
import ContactInformationUs from './ContactInformationUs.vue';
import ContactInformationJapan from './ContactInformationJapan.vue';
import ContactInformationChina from './ContactInformationChina.vue';
import MfaEnable from '@/ui/views/mfa/MfaEnable.vue';
import { computed, ref } from 'vue';
import { useValidator } from '@/core/app.service';
import AccountService from '@/services/account.service';
import { store } from '@/store';
import { useNewsletter } from '@/store/newsletter.composable';
import { MfaType } from '@/enums';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileDetails',
  props: {
    showMultiFactorAuthentication: { type: Boolean },
    changePasswordUrl: null,
    logoutPageUrl: null,
    states: null,
    isUsMarket: { type: Boolean },
    isJapanMarket: { type: Boolean },
    isChinaMarket: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    showMultiFactorAuthentication: boolean;
    changePasswordUrl: string,
    logoutPageUrl: string,
    states: StateViewObject[],
    isUsMarket: boolean,
    isJapanMarket: boolean,
    isChinaMarket: boolean
}



const labelNamespace = 'Pages.MyAccount.ProfileDetails';

const form = ref<Vertica.LouisPoulsen.Application.Account.Api.Requests.UpdateUserRequest>({
    city: '',
    countryCode: null,
    firstName: '',
    multiFactorAuthentication: 0,
    lastName: '',
    phone: '',
    postalCode: '',
    region: null,
    streetName: '',
    streetNumber: '',
    subRegion: null,
    subUnit: null
});
const showSpinner = ref<boolean>(false);
const showMfaMessage = ref<boolean>(false);
const mfaRequestSuccess = ref<boolean>(false);
const email = computed<string>(() => profileDetails.value ? profileDetails.value.email : '');

const $validator = useValidator();

const { setPrefilledNewsletterSignupInformation } = useNewsletter();

function toggleNewsletterModal() {
    setPrefilledNewsletterSignupInformation(newsletterRequest.value);
    store.dispatch('navigation/toggleNewsletterModal');
}

const newsletterRequest = computed<IPrefilledNewsletterSignupRequestForm>(() => {
    return {
        firstName: form.value.firstName,
        lastName: form.value.lastName,
        emailAddress: email.value
    };
});

const profileDetails = ref<AccountInformationViewObject>(null);
const originalMfaState = ref<Vertica.LouisPoulsen.Login.Database.Models.Enums.MfaType>(null);
const mfaState = ref<MultiFactorAuthenticationViewObject>(null);

async function loadProfileDetails() : Promise<AccountInformationViewObject> {
    const profile = await AccountService.getProfileDetails();
    profileDetails.value = profile;
    return profile;
}

async function loadMfaSettings() {
    const mfaSettings = await AccountService.getMfaSettings();
    mfaState.value = mfaSettings;
    form.value.multiFactorAuthentication = mfaSettings.current;
    originalMfaState.value = mfaSettings.current;
}

loadProfileDetails().then((profile) => {
    form.value.city = (profile.address && profile.address.city) || '';
    form.value.firstName = profile.firstName;
    form.value.lastName = profile.lastName;
    form.value.phone = (profile.address && profile.address.phone) || '';
    form.value.postalCode = (profile.address && profile.address.postalCode) || '';
    form.value.streetName = (profile.address && profile.address.streetName) || '';
    form.value.streetNumber = (profile.address && profile.address.streetNumber) || '';
    form.value.region = (profile.address && profile.address.region) || null;
    form.value.subRegion = (profile.address && profile.address.subRegion) || null;
    form.value.subUnit = (profile.address && profile.address.subUnit) || null;
});

if (props.showMultiFactorAuthentication) {
    loadMfaSettings();
} else {
    setMfaState(MfaType.None);
}

async function updateAccount() {
    showMfaMessage.value = false;
    mfaRequestSuccess.value = false;
    showSpinner.value = true;

    $validator.validateAll().then(async(isValid) => {
        if (!isValid) {
            return;
        }

        await AccountService.updateAccount(form.value).finally(() => {
            showSpinner.value = false;
        });
        if (originalMfaState.value !== form.value.multiFactorAuthentication) {
            showMfaMessage.value = true;
            mfaRequestSuccess.value = true;
        }
    });
}

async function setMfaState(state: number) {
    showMfaMessage.value = false;
    mfaRequestSuccess.value = false;
    form.value.multiFactorAuthentication = state;
};

return { __sfc: true,props, labelNamespace, form, showSpinner, showMfaMessage, mfaRequestSuccess, email, $validator, setPrefilledNewsletterSignupInformation, toggleNewsletterModal, newsletterRequest, profileDetails, originalMfaState, mfaState, loadProfileDetails, loadMfaSettings, updateAccount, setMfaState, ContactInformation, ContactInformationUs, ContactInformationJapan, ContactInformationChina, MfaEnable }
}

})